<template>
    <main>
        <div class="sidebar">
            <img class="logo" :src="logo" alt="">
            <img class="machinne" :src="logoMachine" alt="">
        </div>
        <div class="logo-mobile">
            <img :src="logoMobile" alt="">
        </div>
        <div class="form-wrapper">
            <h1 v-html="boxTitle"></h1>
            <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
            <form @submit.prevent>
                <div>
                    <div class="input-group">
                        <label for="email">E-mail</label>            
                        <input type="email" placeholder="Digite o seu e-mail" v-model="credentials.email" v-validate="modelValidations.email" :class="{'is-danger': errors.has('email')}" data-vv-name="email" required>
                        <div v-show="errors.has('email')" class="help">
                            {{ errors.first('email') }}
                        </div>
                    </div>
                    <div class="input-group" v-if="!isSendPassword">
                        <label for="password">Senha</label>
                        <input type="password" placeholder="Digite a sua senha" v-model="credentials.password" v-validate="modelValidations.password" :class="{'is-danger': errors.has('senha')}" data-vv-name="senha" required>
                        <div v-show="errors.has('senha')" class="help">
                            {{ errors.first('senha') }}
                        </div>
                    </div>
                    <div class="actions" v-show="!isResetPassword">
                        <a href="#" @click="sendPassword">{{isSendPassword ? 'Cancelar' : 'Esqueceu sua senha?'}}</a>
                    </div>
                </div>
                <button type="submit" @click.prevent="validate" :disabled="loading">{{buttonTitle}}</button>
            </form>
        </div>
    </main>
</template>
<script>
import accountService from '../../services/Account/accountService'
import config from '../../config'
export default {
    props: {
        rt: String
    },
    data() {
        return {
            hasError: false,
            errorMessage: '',
            loading: false,
            credentials: {
                email: '',
                password: ''
            },
            modelValidations: {
                email: {
                required: true,
                email: true
                },
                password: {
                required: true,
                min: 8
                }
            },
            isSendPassword: false
        }
    },
    computed: {
        isResetPassword() {
            return this.rt ? true : false
        },
        boxTitle() {
            if(this.isResetPassword)
                return 'Alterar Senha'
            if(this.isSendPassword)
                return 'Enviar Senha'            
            return 'Entrar'
        },
        buttonTitle() {
            if(this.isResetPassword)
                return 'Alterar Senha'
            if(this.isSendPassword)
                return 'Enviar Senha'
            if(this.loading)
                return 'Aguarde...'
            return 'Entrar'
        },
        logo() {
            return `img/${config.partnersConfiguration.key}/login/logo.png`
        },
        logoMobile() {
            return `img/${config.partnersConfiguration.key}/login/logo.png`
        },
        logoMachine() {
            return `img/${config.partnersConfiguration.key}/login/machinne.png`
        }
    },
    methods: {
        validate() {
            this.loading = true
            const self = this
            this.hasError = false
            this.errorMessage = ''
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if(self.isResetPassword) {
                        accountService.resetPassword(self.$data.credentials.email, self.$data.credentials.password, self.rt)
                        .then(
                            r => {
                                self.handleSuccessful(self, r)
                            },
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    else if(self.isSendPassword)
                    {
                        accountService.sendToken(self.$data.credentials.email)
                        .then(
                            r => {
                                self.disableSendPassword()
                                self.errorMessage = 'E-mail com informações para nova senha enviada com sucesso!'
                                self.hasError = true
                                self.loading = false
                            },
                            
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    else
                    {
                        accountService.signin(self.$data.credentials.email, self.$data.credentials.password)
                        .then(
                            r => {
                                self.handleSuccessful(self, r)
                            },
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    
                } 
                else 
                {
                    self.loading = false
                }
            })
        },
        handleSuccessful(vw, r) {
            const response = r.data
            if (response && response.authenticated) {
                vw.$store.dispatch('setUser', response)
                window.location = '/'
                return
            }
            vw.errorMessage = response.message
            vw.hasError = true
            vw.loading = false
        },
        handleError(vw, err) {
            const msg = err.response.status == 404 ? err.message : err.response.data.message
            vw.errorMessage = msg
            vw.hasError = true
            vw.loading = false
        },
        sendPassword() {
            this.isSendPassword = !this.isSendPassword
        },
        disableSendPassword() {
            this.isSendPassword = false
        }
    }
}
</script>